import React from 'react';

const PotentialsFootnote3 = () => (
  <>
    <sup>3</sup> Gilt für einen Arbeitstag (Hin- und Rückweg) mit jeweiliger Route laut WHO-Empfehlung.
  </>
);

export default PotentialsFootnote3;
